module.exports = __webpack_public_path__ + "img/aandcon_banner.959ec431.png";